import { render, staticRenderFns } from "./PaktaIntegritas.vue?vue&type=template&id=f6882e4c&"
import script from "./PaktaIntegritas.vue?vue&type=script&lang=js&"
export * from "./PaktaIntegritas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports